var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_1703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 0.333252H2.08333C1.531 0.333781 1.00148 0.509546 0.610925 0.821992C0.220367 1.13444 0.000661607 1.55805 0 1.99992L0 5.99992C0.000661607 6.44178 0.220367 6.8654 0.610925 7.17785C1.00148 7.49029 1.531 7.66606 2.08333 7.66659H7.91667C8.469 7.66606 8.99852 7.49029 9.38908 7.17785C9.77963 6.8654 9.99934 6.44178 10 5.99992V1.99992C9.99934 1.55805 9.77963 1.13444 9.38908 0.821992C8.99852 0.509546 8.469 0.333781 7.91667 0.333252ZM2.08333 0.999919H7.91667C8.16616 1.00031 8.4098 1.06042 8.61623 1.17252C8.82266 1.28462 8.98244 1.44357 9.075 1.62892L5.88417 4.18192C5.64935 4.36902 5.33142 4.47408 5 4.47408C4.66858 4.47408 4.35065 4.36902 4.11583 4.18192L0.925 1.62892C1.01756 1.44357 1.17734 1.28462 1.38377 1.17252C1.5902 1.06042 1.83384 1.00031 2.08333 0.999919ZM7.91667 6.99992H2.08333C1.75181 6.99992 1.43387 6.89456 1.19945 6.70703C0.965029 6.51949 0.833333 6.26514 0.833333 5.99992V2.49992L3.52667 4.65325C3.91776 4.96534 4.44761 5.1406 5 5.1406C5.55239 5.1406 6.08224 4.96534 6.47333 4.65325L9.16667 2.49992V5.99992C9.16667 6.26514 9.03497 6.51949 8.80055 6.70703C8.56613 6.89456 8.24819 6.99992 7.91667 6.99992Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_1703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.306a67de6af44761bd7d7b99f10df89a.svg";
export { ForwardRef as ReactComponent };